import React, { useEffect } from 'react';
import { resolveGaMeasurementId } from '../ga.ts';

const DJAMMA_GA_MEASUREMENT_ID = 'G-PV5BP434XG';

function measurementId(): string {
  return resolveGaMeasurementId({
    hostname: window.location.hostname,
    domainSet: process.env.REACT_APP_DOMAIN_SET || 'djamma',
    envId: process.env.REACT_APP_GA_MEASUREMENT_ID || '',
    fallbackId: DJAMMA_GA_MEASUREMENT_ID,
  });
}

const GoogleAnalytics: React.FC = () => {
  useEffect(() => {
    const GA_MEASUREMENT_ID = measurementId();
    if (!GA_MEASUREMENT_ID) {
      return;
    }
    if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    // gtag.js n'accepte que l'objet Arguments natif (pas un Array via ...args).
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);
  }, []);

  return null;
};

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export default GoogleAnalytics;
